import svg from './row-svg/rapport-technique.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function RapportTechniqueIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default RapportTechniqueIcon;
